import httpService from '@/services/httpService'

export const types = {
  SET_OPTS: 'sections/SET_OPTS',
  SET_SECTIONS: 'sections/SET_SECTIONS'
}

const state = {
  opts: {
    rrp_geo_opts: [],
    rrp_device_opts: [],
    rrp_locale_opts: []
  },
  sections: []
}

const mutations = {
  [types.SET_OPTS]: function (state, opts) {
    state.opts = opts
  },
  [types.SET_SECTIONS]: function (state, sections) {
    state.sections = sections
  }
}

const actions = {
  validate: async function ({ commit, dispatch }, { clientId, ...params }) {
    const response = await httpService.get(`/section/validate/${clientId}`, { params })
    if (!response) {
      return {}
    }
    return response.data
  },
  getSectionData: async function ({ commit, dispatch }, { clientId, filters }) {
    const params = { filters: JSON.stringify(filters) }
    const response = await httpService.get(`/section/${clientId}`, { params })
    if (!response || !response.data) {
      return
    }
    commit(types.SET_SECTIONS, response.data)
    return response.data
  },
  createSection: function ({ commit }, { clientId, section }) {
    return httpService.post(`/section/${clientId}`, section,
      { successMessage: 'Section successfully created', raiseError: true, cancelErrorMessage: true })
  },
  deleteSectionById: function ({ commit }, { clientId, sectionId }) {
    const config = {
      params: {
        id: sectionId
      },
      successMessage: 'Section successfully deleted',
      raiseError: true,
      cancelErrorMessage: true
    }
    return httpService.delete(`/section/${clientId}`, config)
  },
  updateSection: function ({ commit }, { clientId, section }) {
    return httpService.patch(`/section/${clientId}`, section,
      { successMessage: 'Section successfully updated', raiseError: true, cancelErrorMessage: true })
  },
  getSectionRankReportOptions: async function ({ commit }) {
    const response = await httpService.get('/section/options')
    if (!response || !response.data) {
      return
    }
    commit(types.SET_OPTS, response.data)
    return response.data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
